import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;
// 允许重复
exceptedReqs.push(/api\/md\/staff\/.*/i);
console.log(exceptedReqs);
const api = {
  Hospitalization: genStandard("hospitalization", "/api/ip", false),
  /*********** 记账记录 ***********/
  Billing: genStandard("billing", "/api/ip"),
  /*********** 标准费用 ***********/
  FeeStandard: genStandard("feeStandard", "/api/md"),
  MlItem: genStandard("item", "/api/ml"),
  Drug: {
    getDrugs: (para) => apiFuns.get(`/api/drug/stock/rp`, para),
  },
  Fee: para => {
    return new Promise(function (resolve, reject) {
      //做一些异步操作
      let object = {
        total: 2,
        items: [
          {
            patientCode: '226',
            patientName: '胡歌',
            hospitalizationId: '123',
            ipNo: 'ZY221128000016',
            bedNo: 'bedNo',
            name: '心脏置入装置调整术后',
            rpClass: 1,
            standard: '规格',
            unit: "单位",
            quantity: 2,
            price: 10,
            totalPrice: 20,
            execDeptCode: '83',
            doctorCode: '29',
            doctorName: '比尔盖茨',
            issuedTime: '2024-01-01 00:00:00',
            deptCode: '83',
            ipType: '自费',
            returnableQuantity: 2,
            returnQuantity: 2,
            returnAmount: 20,
            disableUserCode: '29',
            disableUserName: '比尔盖茨',
            disableDate: '2024-01-01 00:00:00',
          }
        ]
      }
      resolve(object);
    });

    //return get(`/api/ip/advice/costList`,para)
  },
  Arrears: para => {
    return new Promise(function (resolve, reject) {
      //做一些异步操作
      let object = {
        total: 2,
        items: [
          {
            patientCode: '226',
            patientName: '胡歌',
            age: 37,
            yjjZe: 2000,
            bedNo: '12',
            name: '心脏置入装置调整术后',
            jzje: 3500,
            qfje: 1500,
            sflb: "器材",
            zybq: 'A病区',
            zyzd: '神经性头痛',
            zyts: 20,
            execDeptCode: '83',
            zytime: '2024-01-01 00:00:00',
            deptCode: '83',
          }
        ]
      }
      resolve(object);
    });
    // return get(`/api/ip/advice/arrears`, para)
  },
  DailyFee: para => {
    return new Promise(function (resolve, reject) {
      //做一些异步操作
      let object = {
        total: 2,
        items: [
          {
            patientCode: '226',
            patientName: '胡歌',
            age: 37,
            yjjZe: 2000,
            bedNo: '12',
            name: '心脏置入装置调整术后',
            jzje: 3500,
            qfje: 1500,
            sflb: "器材",
            zybq: 'A病区',
            zyzd: '神经性头痛',
            zyts: 20,
            execDeptCode: '83',
            zytime: '2024-01-01 00:00:00',
            deptCode: '83',
          }
        ]
      }
      resolve(object);
    });

    // return get(`/api/ip/advice/dailyFee`, para)
  }
};

export default api;
